module.exports = __webpack_public_path__ + "static/media/giorgio-armani-acqua-di-gioa-big.daf1921f.png";